'use client';
import { useState, useEffect, useContext } from 'react';

import { SearchContext } from '@/components/context/SearchContext/SearchContext';

import { runSearch } from '@/util/search';
import { VivrelleQuery, SearchQueryResponse } from '@/types/Search';

type UseSearchResponse = {
  loading: boolean;
  results?: SearchQueryResponse;
};

export const useSearch = (query: VivrelleQuery): UseSearchResponse => {
  const [loading, setLoading] = useState<boolean>(true);
  const [searchResults, setSearchResults] = useState<
    undefined | SearchQueryResponse
  >();

  useEffect(() => {
    const runEffect = async () => {
      // Ensures this effect call will only run once
      if (loading === false) {
        return;
      }
      const runSearchResult = await runSearch(query);
      setSearchResults(runSearchResult);
      setLoading(false);
    };

    runEffect();
  }, [query, loading]);

  return {
    loading,
    results: searchResults
  };
};

/**
 * Handles the search bar context
 * TODO: add PLP search functionality to SearchContext
 */
export const useSearchContext = () => {
  const context = useContext(SearchContext);

  return context;
};
